import { Injectable } from "@angular/core";
import { IMaintenanceSummaryModel, IMaintenanceInventoryModel, IMaintenanceReadingModel, IDosageModel, IDosageItemModel } from "@models";
import { HttpService } from "./utils/http.service";

@Injectable()
export class MaintenanceHistoryService {
	constructor(private readonly httpService: HttpService) { }

	async getMaintenanceReading(maintenanceReadingId: number): Promise<IMaintenanceReadingModel> {
		return await this.httpService.get('/maintenanceHistory/getMaintenanceReading', { maintenanceReadingId });
	}

	async addMaintenanceReading(maintenanceReadingModel: IMaintenanceReadingModel): Promise<IMaintenanceReadingModel> {
		return await this.httpService.post('/maintenanceHistory/addMaintenanceReading', maintenanceReadingModel);
	}

	async updateMaintenanceReading(maintenanceReadingModel: IMaintenanceReadingModel): Promise<IMaintenanceReadingModel> {
		return await this.httpService.post('/maintenanceHistory/updateMaintenanceReading', maintenanceReadingModel)
	}

	// structureId omitted returns the customer's whole history; a structure id narrows it to that
	// pool/spa, and 0 returns the "Unassigned" records taken before the Assets tab existed.
	async getMaintenanceSummary(customerId: number, structureId: number = null): Promise<IMaintenanceSummaryModel> {
		if (structureId === null || structureId === undefined)
			return await this.httpService.get('/maintenanceHistory/getMaintenanceSummary', { customerId });

		return await this.httpService.get('/maintenanceHistory/getMaintenanceSummary', { customerId, structureId });
	}

	async getMaintenanceForAppointment(customerId: number, appointmentId: number): Promise<IMaintenanceSummaryModel> {
		return await this.httpService.get('/maintenanceHistory/getMaintenanceForAppointment', { customerId, appointmentId });
	}

	async addMaintenanceInventory(maintenanceInventoryModel: IMaintenanceInventoryModel): Promise<IMaintenanceInventoryModel> {
		return await this.httpService.post('/maintenanceHistory/addMaintenanceInventory', maintenanceInventoryModel);
	}

	async updateMaintenanceInventory(maintenanceInventoryModel: IMaintenanceInventoryModel): Promise<IMaintenanceInventoryModel> {
		return await this.httpService.post('/maintenanceHistory/updateMaintenanceInventory', maintenanceInventoryModel)
	}

	async deleteMaintenanceInventory(maintenanceInventoryId: number): Promise<boolean> {
		return await this.httpService.delete('/maintenanceHistory/deleteMaintenanceInventory', { maintenanceInventoryId })
	}

	async getDosageItems(): Promise<IDosageItemModel[]> {
		return await this.httpService.get('/maintenanceHistory/getDosageItems');
	}

	async getDosage(dosageId: number): Promise<IDosageModel> {
		return await this.httpService.get('/maintenanceHistory/getDosage', { dosageId });
	}

	async addDosage(dosageModel: IDosageModel): Promise<IDosageModel> {
		return await this.httpService.post('/maintenanceHistory/addDosage', dosageModel);
	}

	async updateDosage(dosageModel: IDosageModel): Promise<IDosageModel> {
		return await this.httpService.post('/maintenanceHistory/updateDosage', dosageModel);
	}
}
